<div class=" row no-gutters">
  <div *ngFor="let s of [].constructor(steps);let i = index" class="col text-center">
    <div [ngStyle]="{'color': (i < currentStep) ? color : 'rgb(216, 216, 216)'}" class="step-number pb-1">{{i + 1}}.</div>
    <div [ngStyle]="{'background-color': (i < currentStep) ? color : 'rgb(216, 216, 216)'}" class='step-progress-bar mx-2'></div>
  </div>
</div>
